import {ActionReducerMap} from '@ngrx/store';
import {
  insurerFeatureKey,
  insurerLoadReducer,
  InsurerState,
} from './reducer/insurer/insurer.reducer';
import {
  lobLoadReducer,
  lobsFeatureKey,
  LobState,
} from './reducer/lob/lob.reducer';

export interface State {
  [insurerFeatureKey]: InsurerState;
  [lobsFeatureKey]: LobState;
}

export const store: ActionReducerMap<State> = {
  [insurerFeatureKey]: insurerLoadReducer,
  [lobsFeatureKey]: lobLoadReducer,
};
